import { render, staticRenderFns } from "./CourseEditorFileInput.vue?vue&type=template&id=51e4f975&scoped=true"
import script from "./CourseEditorFileInput.vue?vue&type=script&lang=js"
export * from "./CourseEditorFileInput.vue?vue&type=script&lang=js"
import style0 from "./CourseEditorFileInput.vue?vue&type=style&index=0&id=51e4f975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4f975",
  null
  
)

export default component.exports